<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { RouteLocationRaw } from 'vue-router'
import { iconSizeConfig, sizeConfig, variantConfig } from './variant'
import { NuxtLink } from '#components'

const props = withDefaults(
  defineProps<{
    class?: HTMLAttributes['class']
    variant?: keyof typeof variantConfig
    size?: keyof typeof sizeConfig
    to?: RouteLocationRaw | string
    label?: string
    icon?: string
    target?: HTMLAnchorElement['target']
    iconPosition?: 'left' | 'right'
    iconSize?: keyof typeof iconSizeConfig
    iconClass?: HTMLAttributes['class']
    disabled?: boolean
    loading?: boolean
    ariaLabel?: string
  }>(),
  {
    class: undefined,
    variant: 'primary',
    size: 'default',
    to: undefined,
    label: '',
    target: undefined,
    icon: undefined,
    iconPosition: 'left',
    iconSize: 'default',
    iconClass: undefined,
    ariaLabel: () => 'Button'
  }
)
</script>

<template>
  <component
    :is="to ? NuxtLink : 'button'"
    :class="
      cn(
        'rounded-full flex transition-all justify-center items-center overflow-hidden gap-2 hover:saturate-105 text-sm font-semibold disabled:opacity-80 disabled:cursor-not-allowed relative',
        variantConfig[variant],
        sizeConfig[size],
        {
          'flex-row-reverse': iconPosition === 'right'
        },
        props.class
      )
    "
    :aria-label="props.ariaLabel"
    :disabled="disabled || loading"
    :to="to"
    :target="target"
  >
    <Icon
      v-if="icon"
      :name="icon"
      :size="loading ? 'svg-spinners:ring-resize' : iconSizeConfig[iconSize]"
      :class="cn('shrink-0 relative', props.iconClass)"
    />
    <span v-if="label && label != ''" class="relative" v-text="label"></span>
  </component>
</template>
